import { Component, model, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { TagModel } from '../../../models/tag.model';
import { TagService } from '../../../services/tag.service';

@Component({
  selector: 'app-tag-selector',
  templateUrl: './tag-selector.component.html',
  styleUrl: './tag-selector.component.scss',
  standalone: false,
})
export class TagSelectorComponent implements OnInit {
  selectedTags = model<TagModel[]>([]);
  tags: TagModel[] = [];
  isLoading: boolean = true;

  constructor(private tagService: TagService) {}

  async ngOnInit(): Promise<void> {
    await this.fetchTags();
  }

  fetchTags(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.tagService
        .getAllTags()
        .pipe(take(1))
        .subscribe({
          next: (tags: TagModel[]) => {
            this.tags = tags;
            this.isLoading = false;
            resolve();
          },
        });
    });
  }

  toggleTag(tag: TagModel): void {
    const index = this.selectedTags().findIndex(t => t.id === tag.id);
    if (index === -1) {
      this.selectedTags.set([...this.selectedTags(), tag]);
    } else {
      this.selectedTags.set(this.selectedTags().filter(t => t.id !== tag.id));
    }
  }

  isSelected(tag: TagModel): boolean {
    return this.selectedTags().some(t => t.id === tag.id);
  }
}
